<template>
  <div class="account-groups-wrap">
    <ListFilter
      :formList="filterFormList"
      @search="searchHandle"
      wstyle="background-color: transparent;padding: 0;"
      @newadd="toggleEditor(true)"
      :newadd="true"
      :newaddConfig="{ type: 'primary', plain: true }"
    />

    <div class="account-groups-list">
      <el-table
        :data="list"
        style="width: 100%; color: #232326;"
        :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }"
      >
        <template #empty><Empty style="margin-top: 56px;" /></template>
        <el-table-column prop="carrierCode" label="船公司" min-width="140" />
        <el-table-column prop="groupName" label="分组名称" min-width="180" />
        <el-table-column prop="sort" label="排序" width="120" />
        <el-table-column prop="updatedDate" label="最近更新时间" width="208">
          <template #default="scope">
            <span>{{ scope.row?.updatedDate ? moment(scope.row.updatedDate).format('YYYY MM.DD HH:mm') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="right" width="130">
          <template #default="scope">
            <el-button link type="primary" @click="toggleEditor(true, scope.row)">编辑</el-button>
            <el-popconfirm title="你确定要删除吗?" width="208px">
              <template #reference>
                <el-button link type="danger">删除</el-button>
              </template>
              <template #actions="{ confirm, cancel }">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button type="primary" size="small" @click="deleteHandle(scope.row, confirm)">确定</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <Spagination
        :page="page"
        :size="size"
        :total="total"
        @current-change="val => page = val"
      />
    </div>
  </div>

  <Modal :title="form.id ? '编辑账号分组' : '新建账号分组'" @cancel="toggleEditor(false)" @submit="submitHandle" v-if="showEditor">
    <el-form :model="form" label-position="top">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="船公司" required>
            <el-select v-model="form.carrierCode" placeholder="请选择" clearable :disabled="Boolean(form.id)">
              <el-option v-for="item in carrierList" :label="item.carrierCode" :value="item.carrierCode" :key="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分组名称" required>
            <el-input v-model.trim="form.groupName" placeholder="请输入" maxlength="100" show-word-limit />
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="排序">
            <el-input-number v-model="form.sort" :min="0" :precision="0" controls-position="right" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Modal>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import moment from 'moment';
  import { ElMessage } from 'element-plus';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Empty from '@/components/empty';
  import Modal from '@/components/modal';
  import * as Request from '@/assets/request';

  const filterFormList = ref([
    { type: 'select', field: 'carrierCode', label: '船公司', placeholder: '请选择', options: [] },
    { type: 'input', field: 'groupName', label: '分组名称', placeholder: '请输入' }
  ]);

  const carrierList = ref([]);
  const getAllCarrier = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/getAllCarrier'
    });
    if (result?.code !== 200) return;

    carrierList.value = result?.data || [];
    const options = carrierList.value.map(item => ({ value: item.carrierCode, label: item.carrierCode }));
    filterFormList.value.forEach(item => {
      if (item.field === 'carrierCode') item.options = options;
    });
  };

  const list = ref([]);
  const listQuery = ref({});
  const total = ref(0);
  const size = ref(50);
  const page = ref(1);
  const getList = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/group/searchList',
      data: { ...listQuery.value, page: page.value, size: size.value }
    });
    if (result?.code !== 200) return;

    list.value = result?.data?.content || [];
    total.value = result?.data?.total || 0;
  };

  const searchHandle = data => {
    listQuery.value = { ...data };
    page.value = 1;
  };

  const showEditor = ref(false);
  const form = ref({});
  const toggleEditor = (flag, data) => {
    showEditor.value = flag;
    form.value = flag && data
      ? { id: data.id, carrierCode: data.carrierCode, groupName: data.groupName, sort: data.sort }
      : flag ? { sort: 0 } : {};
  };

  const submitHandle = async () => {
    if (!form.value.carrierCode) {
      ElMessage.warning('请选择船公司');
      return;
    }
    if (!form.value.groupName) {
      ElMessage.warning('请输入分组名称');
      return;
    }
    const isEdit = Boolean(form.value.id);
    const result = await Request.post({
      url: isEdit
        ? '/22001/facade/commons/carrier/account/group/update'
        : '/22001/facade/commons/carrier/account/group/add',
      data: form.value
    });
    if (result?.code !== 200) return;

    ElMessage.success(isEdit ? '编辑成功' : '新建成功');
    toggleEditor(false);
    getList();
  };

  const deleteHandle = async (item, confirm) => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/group/delete',
      data: item.id
    });
    if (result?.code !== 200) return;

    ElMessage.success('已删除');
    confirm();
    getList();
  };

  onMounted(() => {
    getAllCarrier();
    getList();
  });

  watch(() => [listQuery.value, page.value], getList, { deep: true });
</script>

<style scoped lang="less">
  .account-groups-wrap {
    .account-groups-list {
      margin-top: 16px;
      padding: 16px;
      background: #fff;
      border-radius: 4px;
    }
  }
</style>
